console.log('you can use ES6 here : )')



// WEBPACK FOOTER //
// ./assets/js/index.js